import { Input } from '@chakra-ui/react';
import FormInputField from 'components/modules/FormInputField';
import { patchMarsMembershipLinkCardConfirmation } from 'features/membership/api';
import CuminCardLinkFormPage from 'features/membership/components/cumin/CuminCardLinkFormPage';
import { useCardLinkForm } from 'features/membership/hooks/ginger/useCardLinkForm';
import { TEMPLATE_ALIAS_CODE } from 'features/membership/libs/const/aliasCode';
import {
  GingerPagePageTemplateOptionKey,
  membershipPluginPageTemplateOptionState
} from 'features/membership/libs/recoil/selector';
import { PageTemplateOption } from 'features/membership/types';
import { CardLinkFormInputs } from 'features/membership/types/form';
import { FEATURES } from 'libs/features';
import { FC } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useRecoilValue } from 'recoil';

/** VD+CSD カード再連携/入力 */
const GingerCardRelink: FC = () => {
  const confirmPagePath = `${FEATURES.membership.path}/${TEMPLATE_ALIAS_CODE.GINGER}/card-renewal/relink/confirm`;
  const { isMutating, methods, formSubmitHandler } = useCardLinkForm(
    confirmPagePath,
    patchMarsMembershipLinkCardConfirmation
  );
  const templateOptions = useRecoilValue<
    Record<GingerPagePageTemplateOptionKey, PageTemplateOption> | undefined
  >(membershipPluginPageTemplateOptionState(TEMPLATE_ALIAS_CODE.GINGER));

  return (
    <CuminCardLinkFormPage
      isMutating={isMutating}
      // HACK: react-hook-formにて、CuminとGingerのフォーム型の互換性がなくエラーしてしまう
      methods={methods as unknown as UseFormReturn<CardLinkFormInputs>}
      onFormSubmit={formSubmitHandler}
      templateOptions={templateOptions}
      isTermActive={false}
      additionalField={
        <FormInputField
          label="PIN番号"
          warning={
            templateOptions?.cardFormPinCodeNoticeContentOption?.content ?? ''
          }
          error={methods.formState.errors.pin_code?.message}
          isRequired={true}
        >
          <Input
            type="tel"
            placeholder={
              templateOptions?.cardFormPinCodePlaceholderContentOption
                ?.content ?? '0000'
            }
            {...methods.register('pin_code')}
          />
        </FormInputField>
      }
    />
  );
};

export default GingerCardRelink;
